<div class="supplementary-equipment">
  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc.transport.supplementaryEquipment.takeBack.title"></sc-dictionary-label>
    </h2>

    <div class="top-info">
      {{handout.name}} {{handout.firstname}} {{handout.company}}
    </div>

    <div class="dialog-content" [formGroup]="formGroup">
      <sc-flex vertical stretchContent class="no-field-space">

        <ng-container *ngIf="supplementaryEquipmendHandouted(handout)">
          <ng-container *ngFor="let se of handout.supplementaryEquipments; let i = index">

            <sc-content-spacer vertical *ngIf="i > 0"></sc-content-spacer>

            <sc-flex [formGroupName]="se.key+i">
              <sc-checkbox-field [disabled]="isFormReadonly()" [labelDictionaryKey]="se.dictionaryKey"
                  formControlName="selected"></sc-checkbox-field>
              <ng-container *ngIf="se.identifier">
                <sc-content-spacer></sc-content-spacer>
                <sc-string-field [disabled]="true" labelDictionaryKey="tmc-common.entity.equipment.identifier"></sc-string-field>
              </ng-container>
              <sc-content-spacer></sc-content-spacer>
                <sc-string-field [disabled]="true" *ngIf="isParam1Available(se)" [labelDictionaryKey]="se.parameter1DictionaryKey"
                  formControlName="parameter1Value"></sc-string-field>
            </sc-flex>

          </ng-container>
        </ng-container>

        <div *ngIf="!supplementaryEquipmendHandouted(handout)">
          <sc-dictionary-label dictionaryKey="tmc.transport.supplementaryEquipment.takeBack.label.nosupplementaryequipmenthandout"></sc-dictionary-label>
        </div>

      </sc-flex>
    </div>


    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button class="cancel-button" (click)="cancel()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary (click)="save()" class="confirm-button" [disabled]="isSaveDisabled()"></sc-save-button>
    </sc-actionbar>
  </div>

</div>
